@if (authService.isAuthenticated$ | async) {
    <form>
        <button mat-flat-button type="button" (click)="openLogoutDialog()">
            <mat-icon>logout</mat-icon>
            Kijelentkezés
        </button>
    </form>
} @else {
    <form>
        <button mat-flat-button type="button" (click)="authService.loginWithRedirect()">
            <mat-icon>login</mat-icon>
            Bejelentkezés
        </button>
    </form>
}
